(() => {
  'use strict';

  const OFFER = Object.freeze({
    eligibleProductIds: new Set([
      8328215658562,
      7701425160258,
      7477298561090,
      7477292204098
    ]),
    giftVariantId: 42137735921730,
    requiredQuantity: 6,
    giftProperty: '_premium_6_gift'
  });

  const nativeFetch = window.fetch.bind(window);
  let syncPromise = null;
  let syncTimer = null;

  function isCartMutation(input) {
    const url = typeof input === 'string' ? input : input?.url || '';
    return /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url);
  }

  async function requestCart(path, body) {
    const response = await nativeFetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const error = new Error(`Cart request failed with ${response.status}`);
      error.status = response.status;
      throw error;
    }

    return response.json();
  }

  function refreshCartUi() {
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }

    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  }

  async function synchronizeGift() {
    if (syncPromise) return syncPromise;

    syncPromise = (async () => {
      const cartResponse = await nativeFetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!cartResponse.ok) return false;

      const cart = await cartResponse.json();
      const eligibleQuantity = cart.items.reduce((total, item) => {
        const isEligibleOneTimePurchase =
          OFFER.eligibleProductIds.has(Number(item.product_id)) && !item.selling_plan_allocation;
        return total + (isEligibleOneTimePurchase ? item.quantity : 0);
      }, 0);

      const giftItems = cart.items.filter(item => Number(item.variant_id) === OFFER.giftVariantId);
      const automaticGift = giftItems.find(item => String(item.properties?.[OFFER.giftProperty]) === 'true');
      const hasGift = giftItems.length > 0;
      const qualifies = eligibleQuantity >= OFFER.requiredQuantity;
      let changed = false;

      if (qualifies && !hasGift) {
        await requestCart('/cart/add.js', {
          items: [{
            id: OFFER.giftVariantId,
            quantity: 1,
            properties: { [OFFER.giftProperty]: 'true' }
          }]
        });
        changed = true;
      } else if (!qualifies && automaticGift) {
        await requestCart('/cart/change.js', { id: automaticGift.key, quantity: 0 });
        changed = true;
      } else if (automaticGift && automaticGift.quantity !== 1) {
        await requestCart('/cart/change.js', { id: automaticGift.key, quantity: 1 });
        changed = true;
      }

      if (changed) refreshCartUi();
      return changed;
    })()
      .catch(error => {
        if (error?.status !== 422) console.error('[Premium 6 gift]', error);
        return false;
      })
      .finally(() => {
        syncPromise = null;
      });

    return syncPromise;
  }

  function scheduleSync(delay = 300) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(synchronizeGift, delay);
  }

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    if (response.ok && isCartMutation(args[0])) scheduleSync();
    return response;
  };

  document.addEventListener('cart:refresh', () => scheduleSync(0));
  document.addEventListener('cart:updated', () => scheduleSync(0));
  document.addEventListener('DOMContentLoaded', () => scheduleSync(0), { once: true });
})();
